import React from 'react';
import { Typography, Space } from 'antd';
import { motion } from 'framer-motion';
import { standardVariants, containerVariants } from '../../utils/useAnimations';

const { Title, Paragraph } = Typography;

export const ProjectSection: React.FC = () => {
  return (
    <section id="projet" className="px-20 pt-20 pb-12">
      <motion.div 
        className="max-w-[848px] mx-auto text-center"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
      >
        <motion.div variants={standardVariants}>
          <Title level={2} className="!text-4xl !font-bold !mb-10">
            Un projet bénévole
          </Title>
        </motion.div>

        <motion.div 
          className="flex flex-col items-start text-left gap-2 mb-8"
          variants={standardVariants}
        >
          <Paragraph className="!text-lg !align-left !leading-relaxed !m-0">
            Ce projet est porté par <a className="benevole" href='https://www.linkedin.com/in/felixbocquet/' target='_blank'>Félix</a>, designer de solutions, <a className="benevole" href='https://www.linkedin.com/in/anaissortais/' target='_blank'>Anaïs</a>, UX UI designer en situation de handicap, et <a className="benevole" href='https://www.linkedin.com/in/axel-fr/' target='_blank'>Axel</a>, Développeur Web. Un projet issue de notre envie commune de sensibiliser, transmettre et faire bouger les lignes (de code).
          </Paragraph>          
          <Paragraph className="!text-lg !leading-relaxed !m-0">
            Nous ne tirons aucun revenu de ce projet, mais vos soutiens sont précieux pour :
          </Paragraph>
        </motion.div>
        
        <motion.div 
          className="flex gap-6 justify-between"
          variants={containerVariants}
        >  
          <motion.div variants={standardVariants}>
            <Space align="center" className="text-lg font-bold">
              <img src="/img/svg/puces/ellipse.svg" className="w-7 h-7 text-neutral-400" alt='' />
              <span>Rendre le site plus accessible</span>
            </Space>
          </motion.div>
          <motion.div variants={standardVariants}>
            <Space align="center" className="text-lg font-bold">
              <img src="/img/svg/puces/virus.svg" className="w-7 h-7 text-neutral-400" alt='' />
              <span>Faire grandir le projet</span>
            </Space>
          </motion.div>
          <motion.div variants={standardVariants}>
            <Space align="center" className="text-lg font-bold">
              <img src="/img/svg/puces/flower.svg" className="w-7 h-7 text-neutral-400"  alt=''/>
              <span>Sensibiliser plus de monde</span>
            </Space>
          </motion.div>
        </motion.div>
      </motion.div>
    </section>
  );
};